<app-modal-frame [headerText]="CONST.HEADER" (emitExit)="onClose($event)">
  <div [formGroup]="closeUldForm" class="close-modal-container">
    <ion-row>
      <ion-col size="auto" class="custom-col">
        <div class="md-control text-box-container disabled-input-box-container">
          <app-form-input-field
            [label]="CONST.SORT_DATE"
            [formControlName]="IDS.SORT_DATE"
            [disabled]="true"
          ></app-form-input-field>
        </div>
      </ion-col>

      <ion-col size="auto">
        <div class="md-control text-box-container disabled-input-box-container">
          <app-form-input-field
            [label]="CONST.SORT"
            [formControlName]="IDS.SORT"
            [disabled]="true"
          ></app-form-input-field>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="mt-12">
      <ion-col size="auto" class="custom-col">
        <div class="md-control text-box-container disabled-input-box-container">
          <app-form-input-field
            [label]="CONST.LOAD_NAME"
            [formControlName]="IDS.LOAD"
            [disabled]="true"
          ></app-form-input-field>
        </div>
      </ion-col>

      <ion-col size="auto">
        <div class="md-control text-box-container disabled-input-box-container">
          <app-form-input-field
            [label]="CONST.EQUIPMENT_NUMBER"
            [formControlName]="IDS.EQUIPMENT_NUMBER"
            [disabled]="true"
          ></app-form-input-field>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="mt-12">
      <ion-col size="auto" class="d-flex">
        <p class="count-label mr-47">ULD Count: {{ data.rowData.uldCount }}</p>
        <p class="count-label">Loose Count: {{ data.rowData.losseCount }}</p>
      </ion-col>
    </ion-row>
    <ion-row class="mt-12">
      <ion-col size="auto">
        <div class="md-control text-box-container">
          <app-form-input-field
            [label]="CONST.PERCENTAGE"
            [formControlName]="IDS.PERCENTAGE"
            [placeholder]="CONST.PERCENTAGE_PLACEHOLDER"
          ></app-form-input-field>
        </div>
      </ion-col>
    </ion-row>

    <div class="footer">
      <ion-button class="back-btn footer-btn" fill="outline" (click)="cancel()">
        {{ CONST.CANCEL }}
      </ion-button>
      <ion-button
        class="transfer-btn footer-btn"
        [disabled]="closeUldForm.invalid"
        (click)="submit()"
      >
        {{ CONST.SUBMIT }}
      </ion-button>
    </div>
  </div>
</app-modal-frame>
